export default __webpack_public_path__ + "static/media/Image (9).de4f3e3e.png";